// extracted by mini-css-extract-plugin
export default {"root":"EmptyList_root__-wjxr","text":"EmptyList_text__uSs79","warning":"EmptyList_warning__c5qBN","button":"EmptyList_button__f2vfC"};